const FORMALIZACAO = {
  EXCLUIR_PROTOCOLO: 'formalizacao-excluir-protocolo',
  MENU_PROTOCOLO: 'formalizacao-menu-protocolo',
  PROTOCOLO_CONSULTA_SOLICITACAO_CONTRATO: 'formalizacao-protocolo-consulta-solicitacao-contrato',
  PROTOCOLO_EXPEDICAO_CONFERENCIA: 'formalizacao-protocolo-expedicao-conferencia',
  PROTOCOLO_EXPEDICAO_DEVOLUCAO: 'formalizacao-protocolo-expedicao-devolucao',
  PROTOCOLO_EXPEDICAO: 'formalizacao-protocolo-expedicao',
  PROTOCOLO_EXPEDIR_CAIXA: 'formalizacao-protocolo-expedir-caixa',
  PROTOCOLO_INICIO: 'formalizacao-protocolo-inicio',
  PROTOCOLO_PREPARACAO: 'formalizacao-protocolo-preparacao',
  PROTOCOLO_RECEPCIONAR: 'formalizacao-protocolo-recepcionar',
  PROTOCOLO_SOLICITACAO_CONTRATO: 'formalizacao-protocolo-solicitacao-contrato',
  RECEPCAO_CADASTRAR_CAIXA: 'formalizacao-recepcao-cadastrarCaixa',
  RECEPCAO_REIMPRESSAO: 'formalizacao-recepcao-reimpressao',
  PROTOCOLO_PRINCIPAL: 'formalizacao-envio-protocolo',
  PROTOCOLO_COMPLEMENTO: 'formalizacao-envio-protocolo-complemento/regularizacao',
  PROTOCOLO_CONSIGNADO: 'formalizacao-envio-protocolo-cartao-consignado',
  PROTOCOLO_CANCELADO: 'formalizacao-envio-protocolo-cancelado/recusado',
  PROTOCOLO_ORIGINAL: 'formalizacao-envio-protocolo-devolução-de-original',
  PROTOCOLO_CONSULTA: 'formalizacao-consulta-protocolo',
};

const LOJAS = {
  EXCLUIR_PROTOCOLO: 'lojas-excluir-protocolo',
  MENU_PROTOCOLO: 'lojas-menu-protocolo',
  PROTOCOLO_CONSULTA_SOLICITACAO_CONTRATO: 'lojas-protocolo-consulta-solicitacao-contrato',
  PROTOCOLO_EXPEDICAO_CONFERENCIA: 'lojas-protocolo-expedicao-conferencia',
  PROTOCOLO_EXPEDICAO_DEVOLUCAO: 'lojas-protocolo-expedicao-devolucao',
  PROTOCOLO_EXPEDICAO: 'lojas-protocolo-expedicao',
  PROTOCOLO_EXPEDIR_CAIXA: 'lojas-protocolo-expedir-caixa',
  PROTOCOLO_INICIO: 'lojas-protocolo-inicio',
  PROTOCOLO_PREPARACAO: 'lojas-protocolo-preparacao',
  PROTOCOLO_RECEPCIONAR: 'lojas-protocolo-recepcionar',
  PROTOCOLO_SOLICITACAO_CONTRATO: 'lojas-protocolo-solicitacao-contrato',
  RECEPCAO_CADASTRAR_CAIXA: 'lojas-recepcao-cadastrarCaixa',
  RECEPCAO_REIMPRESSAO: 'lojas-recepcao-reimpressao',
  PROTOCOLO_PRINCIPAL: 'lojas-envio-protocolo',
  PROTOCOLO_COMPLEMENTO: 'lojas-envio-protocolo-complemento/regularizacao',
  PROTOCOLO_CONSIGNADO: 'lojas-envio-protocolo-cartao-consignado',
  PROTOCOLO_CANCELADO: 'lojas-envio-protocolo-cancelado/recusado',
  PROTOCOLO_ORIGINAL: 'lojas-envio-protocolo-devolução-de-original',
  PROTOCOLO_CONSULTA: 'lojas-consulta-protocolo',
};

const CORRESPONDENTE = {
  EXCLUIR_PROTOCOLO: 'correspondente-excluir-protocolo',
  MENU_PROTOCOLO: 'correspondente-menu-protocolo',
  PROTOCOLO_CONSULTA_SOLICITACAO_CONTRATO: 'correspondente-protocolo-consulta-solicitacao-contrato',
  PROTOCOLO_EXPEDICAO_CONFERENCIA: 'correspondente-protocolo-expedicao-conferencia',
  PROTOCOLO_EXPEDICAO_DEVOLUCAO: 'correspondente-protocolo-expedicao-devolucao',
  PROTOCOLO_EXPEDICAO: 'correspondente-protocolo-expedicao',
  PROTOCOLO_EXPEDIR_CAIXA: 'correspondente-protocolo-expedir-caixa',
  PROTOCOLO_INICIO: 'correspondente-protocolo-inicio',
  PROTOCOLO_PREPARACAO: 'correspondente-protocolo-preparacao',
  PROTOCOLO_RECEPCIONAR: 'correspondente-protocolo-recepcionar',
  PROTOCOLO_SOLICITACAO_CONTRATO: 'correspondente-protocolo-solicitacao-contrato',
  RECEPCAO_CADASTRAR_CAIXA: 'correspondente-recepcao-cadastrarCaixa',
  RECEPCAO_REIMPRESSAO: 'correspondente-recepcao-reimpressao',
  PROTOCOLO_PRINCIPAL: 'correspondente-envio-protocolo',
  PROTOCOLO_COMPLEMENTO: 'correspondente-envio-protocolo-complemento/regularizacao',
  PROTOCOLO_CONSIGNADO: 'correspondente-envio-protocolo-cartao-consignado',
  PROTOCOLO_CANCELADO: 'correspondente-envio-protocolo-cancelado/recusado',
  PROTOCOLO_ORIGINAL: 'correspondente-envio-protocolo-devolução-de-original',
  PROTOCOLO_CONSULTA: 'correspondente-consulta-protocolo',
};

const CONVENIOS = {
  EXCLUIR_PROTOCOLO: 'convenios-excluir-protocolo',
  MENU_PROTOCOLO: 'convenios-menu-protocolo',
  PROTOCOLO_CONSULTA_SOLICITACAO_CONTRATO: 'convenios-protocolo-consulta-solicitacao-contrato',
  PROTOCOLO_EXPEDICAO_CONFERENCIA: 'convenios-protocolo-expedicao-conferencia',
  PROTOCOLO_EXPEDICAO_DEVOLUCAO: 'convenios-protocolo-expedicao-devolucao',
  PROTOCOLO_EXPEDICAO: 'convenios-protocolo-expedicao',
  PROTOCOLO_EXPEDIR_CAIXA: 'convenios-protocolo-expedir-caixa',
  PROTOCOLO_INICIO: 'convenios-protocolo-inicio',
  PROTOCOLO_PREPARACAO: 'convenios-protocolo-preparacao',
  PROTOCOLO_RECEPCIONAR: 'convenios-protocolo-recepcionar',
  PROTOCOLO_SOLICITACAO_CONTRATO: 'convenios-protocolo-solicitacao-contrato',
  RECEPCAO_CADASTRAR_CAIXA: 'convenios-recepcao-cadastrarCaixa',
  RECEPCAO_REIMPRESSAO: 'convenios-recepcao-reimpressao',
  PROTOCOLO_PRINCIPAL: 'convenios-envio-protocolo',
  PROTOCOLO_COMPLEMENTO: 'convenios-envio-protocolo-complemento/regularizacao',
  PROTOCOLO_CONSIGNADO: 'convenios-envio-protocolo-cartao-consignado',
  PROTOCOLO_CANCELADO: 'convenios-envio-protocolo-cancelado/recusado',
  PROTOCOLO_ORIGINAL: 'convenios-envio-protocolo-devolução-de-original',
  PROTOCOLO_CONSULTA: 'convenios-consulta-protocolo',
};

const GESTAOPENDENCIAS = {
  EXCLUIR_PROTOCOLO: 'gestaopendencias-excluir-protocolo',
  MENU_PROTOCOLO: 'gestaopendencias-menu-protocolo',
  PROTOCOLO_CONSULTA_SOLICITACAO_CONTRATO: 'gestaopendencias-protocolo-consulta-solicitacao-contrato',
  PROTOCOLO_EXPEDICAO_CONFERENCIA: 'gestaopendencias-protocolo-expedicao-conferencia',
  PROTOCOLO_EXPEDICAO_DEVOLUCAO: 'gestaopendencias-protocolo-expedicao-devolucao',
  PROTOCOLO_EXPEDICAO: 'gestaopendencias-protocolo-expedicao',
  PROTOCOLO_EXPEDIR_CAIXA: 'gestaopendencias-protocolo-expedir-caixa',
  PROTOCOLO_INICIO: 'gestaopendencias-protocolo-inicio',
  PROTOCOLO_PREPARACAO: 'gestaopendencias-protocolo-preparacao',
  PROTOCOLO_RECEPCIONAR: 'gestaopendencias-protocolo-recepcionar',
  PROTOCOLO_SOLICITACAO_CONTRATO: 'gestaopendencias-protocolo-solicitacao-contrato',
  RECEPCAO_CADASTRAR_CAIXA: 'gestaopendencias-recepcao-cadastrarCaixa',
  RECEPCAO_REIMPRESSAO: 'gestaopendencias-recepcao-reimpressao',
  PROTOCOLO_PRINCIPAL: 'gestaopendencias-envio-protocolo',
  PROTOCOLO_COMPLEMENTO: 'gestaopendencias-envio-protocolo-complemento/regularizacao',
  PROTOCOLO_CONSIGNADO: 'gestaopendencias-envio-protocolo-cartao-consignado',
  PROTOCOLO_CANCELADO: 'gestaopendencias-envio-protocolo-cancelado/recusado',
  PROTOCOLO_ORIGINAL: 'gestaopendencias-envio-protocolo-devolução-de-original',
  PROTOCOLO_CONSULTA: 'gestaopendencias-consulta-protocolo',
};

const ROLES = {
  FORMALIZACAO,
  CORRESPONDENTE,
  CONVENIOS,
  GESTAOPENDENCIAS,
  LOJAS,
};

export { ROLES };
